import { createContext, useContext } from "react";
import type { ServiceDesk } from "./use-service-desk";

/**
 * Whether the Service Desk can be used here, for the pickers below the builder (the Add-step menu, the trigger picker). The
 * builder's `RefsProvider` reads it once from the server's navigation and supplies it; outside one nothing is known, so nothing
 * is locked. In a module of its own with only `react` to import, so the provider and its readers always share one object
 * (see `refs-context.ts`).
 */
export const ServiceDeskContext = createContext<ServiceDesk>({ state: "unknown", minPlan: "standard" });

export function useServiceDeskState(): ServiceDesk {
  return useContext(ServiceDeskContext);
}
